var _a;
import { __assign, __read, __values } from "tslib";
import { handleActions } from 'redux-actions';
import produce from 'immer';
import { clearSelectedSubsidies, selectSubsidy, setCheckSubsidyResult, setSubsidiesError, setSubsidiesLoading, setSubsidiesResultsOpen, setSubsidiesState } from './actions';
export var initialState = {
    selectSubsidiesError: null,
    subsidiesResultInitialPrice: null,
    availableSubsidiesByPassengers: {},
    subsidiesResultByPassengersSegments: {},
    selectedSubsidies: {},
    isLoading: false,
    resultsOpen: false
};
export default handleActions((_a = {},
    _a[setSubsidiesState.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign({}, payload));
    },
    _a[setSubsidiesLoading.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { isLoading: payload }));
    },
    _a[setSubsidiesResultsOpen.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { resultsOpen: payload }));
    },
    _a[setCheckSubsidyResult.toString()] = function (state, _a) {
        var payload = _a.payload;
        if (!payload) {
            return state;
        }
        return produce(state, function (draft) {
            var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
            var slice = {};
            draft.subsidiesResultInitialPrice = payload.initialOrderPrice;
            try {
                for (var _e = __values(payload.segments), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var segment = _f.value;
                    try {
                        for (var _g = (e_2 = void 0, __values(segment.travellers)), _h = _g.next(); !_h.done; _h = _g.next()) {
                            var responsePassenger = _h.value;
                            var travellerId = responsePassenger.traveller.id;
                            var segmentId = segment.segment.id;
                            if (!slice[travellerId]) {
                                slice[travellerId] = {};
                            }
                            if (!slice[travellerId][segmentId]) {
                                slice[travellerId][segmentId] = [];
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_1) throw e_1.error; }
            }
            try {
                for (var _j = __values(payload.segments), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var segment = _k.value;
                    try {
                        for (var _l = (e_4 = void 0, __values(segment.travellers)), _m = _l.next(); !_m.done; _m = _l.next()) {
                            var responsePassenger = _m.value;
                            slice[responsePassenger.traveller.id][segment.segment.id].push({
                                segmentId: segment.segment.id,
                                id: responsePassenger.subsidyInfo.subsidyId,
                                discount: responsePassenger.subsidyInfo.discount,
                                initialPrice: responsePassenger.subsidyInfo.initialPrice,
                                rejectMessage: responsePassenger.subsidyInfo.rejectMessage,
                                resultPrice: responsePassenger.subsidyInfo.resultPrice
                            });
                            draft.subsidiesResultByPassengersSegments = slice;
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                }
                finally { if (e_3) throw e_3.error; }
            }
        });
    },
    _a[setSubsidiesError.toString()] = function (state, _a) {
        var payload = _a.payload;
        return __assign(__assign({}, state), { selectSubsidiesError: payload });
    },
    _a[clearSelectedSubsidies.toString()] = function (state) {
        return produce(state, function (draft) {
            var e_5, _a;
            try {
                for (var _b = __values(Object.entries(state.selectedSubsidies)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 1), passengerId = _d[0];
                    draft.selectedSubsidies[passengerId] = [];
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
        });
    },
    _a[selectSubsidy.toString()] = function (state, _a) {
        var payload = _a.payload;
        return produce(state, function (draft) {
            var payloadSubsidy = { subsidyId: payload.subsidyId, segmentId: payload.segmentId };
            var alreadySelectedSubsidyIndex = draft.selectedSubsidies[payload.passengerId].findIndex(function (alreadySelected) {
                return alreadySelected.subsidyId === payloadSubsidy.subsidyId &&
                    alreadySelected.segmentId === payloadSubsidy.segmentId;
            });
            if (alreadySelectedSubsidyIndex !== -1) {
                draft.selectedSubsidies[payload.passengerId].splice(alreadySelectedSubsidyIndex, 1);
            }
            else {
                draft.selectedSubsidies[payload.passengerId].push(payloadSubsidy);
            }
        });
    },
    _a), initialState);
